import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import MISSING_NORMALIZED_PATHS from "@gql/queries/missingNormalizedPaths";

const DEFAULT_IGNORE = ["client.parties", "client.children"];
const OPTIONAL_SUFFIXES = new Set(["middleName", "street2", "orgName"]);

export default function useMissingNormalizedPaths({ clientId, paths, taxYear, ignoreIfAbsent }) {
  const variables = useMemo(() => {
    const basePaths = paths || [];
    // Auto-ignore any fields ending with optional suffixes that appear in the template paths
    const autoOptionalIgnores = basePaths.filter((p) =>
      OPTIONAL_SUFFIXES.has((p || "").split(".").pop()),
    );
    const explicitIgnores = ignoreIfAbsent && ignoreIfAbsent.length ? ignoreIfAbsent : [];
    const ignore = Array.from(
      new Set([...DEFAULT_IGNORE, ...autoOptionalIgnores, ...explicitIgnores]),
    );
    return {
      clientId,
      paths: basePaths,
      taxYear: taxYear ? Number(taxYear) : undefined,
      ignore,
    };
  }, [clientId, paths, taxYear, ignoreIfAbsent]);

  const skip = !clientId || !paths || paths.length === 0;

  const result = useQuery(MISSING_NORMALIZED_PATHS, {
    variables,
    skip,
    fetchPolicy: "cache-and-network",
  });

  return result;
}
